import React, { useState, useEffect } from "react";
import { Alert, Button, ListGroup, Modal, Spinner } from "react-bootstrap";
import InfiniteScroll from "react-infinite-scroll-component";
import "./checkBox.css";

const CheckBoxList = (props) => {
  const {
    items,
    onChecked,
    title,
    buttonLabel,
    onSave,
    onHide,
    show,
    showTitleIcon,
    loader,
    emptyText,
    isAvatar,
    defaultAvatar,
    isRadio,
    value,
    onPageChange,
    isAvatarCover,
    modalSize = "md",
    totalItems,
    currentPage,
    disabledIds = [], // IDs that cannot be unchecked
  } = props;

  const [checked, setchecked] = useState([]);
  const [searchTerm, setSearchTerm] = useState("");
  const [allItems, setAllItems] = useState([]);
  const [initialValue, setInitialValue] = useState([]);

  // Update checked state when value prop changes (but don't update initialValue)
  useEffect(() => {
    if (value) {
      setchecked([...value]);
    } else {
      setchecked([]);
    }
  }, [value]);

  // Reset accumulated items and checked state when modal opens
  useEffect(() => {
    if (show) {
      setAllItems([]);
      setSearchTerm("");
      // Store the initial value when modal opens and reset checked to it
      // eslint-disable-next-line react-hooks/exhaustive-deps
      const initial = value ? [...value] : [];
      setchecked(initial);
      setInitialValue(initial);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [show]);

  // Accumulate items across pages so earlier pages remain visible
  useEffect(() => {
    if (!items || items.length === 0) {
      return;
    }

    if (currentPage <= 1) {
      setAllItems(items);
    } else {
      setAllItems((prev) => {
        const existingIds = new Set(prev.map((it) => it.id));
        const newItems = items.filter((it) => !existingIds.has(it.id));

        return [...prev, ...newItems];
      });
    }
  }, [items, currentPage]);

  // Filter items based on search term
  const filteredItems =
    allItems?.filter((item) =>
      item.name.toLowerCase().includes(searchTerm.toLowerCase())
    ) || [];

  const addChecked = (bool, id) => {
    // Prevent unchecking disabled IDs
    if (!bool && disabledIds.includes(id)) {
      return;
    }

    const selected = bool
      ? [...checked, id]
      : checked.filter((cid) => cid !== id);
    setchecked(selected);
    onChecked && onChecked(selected);
  };

  const Hide = () => {
    // Reset to original value when closing without saving
    setchecked([...initialValue]);
    onHide();
  };

  const onBtnClick = () => {
    const selectedItems = (allItems || []).filter((item) =>
      checked.includes(item.id)
    );
    onSave && onSave(checked, selectedItems);
    Hide();
  };

  const loadNextPage = () => {
    if (loader) return;
    onPageChange(currentPage + 1);
  };

  const isSearchActive = searchTerm.trim().length > 0;
  const hasMoreItems =
    Boolean(totalItems) &&
    !loader &&
    !isSearchActive &&
    allItems.length < totalItems &&
    allItems.length > 0;

  return (
    <Modal
      show={show}
      onHide={Hide}
      size={modalSize}
      aria-labelledby="contained-modal-title-vcenter"
      centered
    >
      <Modal.Header className="no-border">
        <Modal.Title id="contained-modal-title-vcenter">
          <div className="dialogheader">
            <div className="d-flex">
              {showTitleIcon ? (
                <img
                  className="iconstyle"
                  src={require("../../../assets/icons/toolkit_light20@3x.png")}
                  alt="icon"
                />
              ) : null}

              <h5 style={{ fontWeight: "bolder" }}>{title}</h5>
            </div>
            <img
              className="iconstyle crossicon"
              src={require("../../../assets/icons/x_light50@3x.png")}
              alt="icon"
              onClick={Hide}
            />
          </div>
        </Modal.Title>
      </Modal.Header>
      <Modal.Body className={`modalBodyStyles`}>
        {/* Search Input */}
        <div className="mb-3">
          <input
            type="text"
            className="form-control"
            placeholder="Search..."
            value={searchTerm}
            onChange={(e) => setSearchTerm(e.target.value)}
            style={{
              border: "1px solid #ddd",
              borderRadius: "4px",
              padding: "8px 12px",
              fontSize: "14px",
            }}
          />
        </div>

        {filteredItems?.length < 1 && !loader ? (
          <Alert variant="danger">{emptyText}</Alert>
        ) : (
          <div style={{ position: "relative" }}>
            <InfiniteScroll
              dataLength={filteredItems?.length || 0}
              next={loadNextPage}
              hasMore={hasMoreItems}
              loader={
                <div className="center-div">
                  <Spinner animation="border" variant="success" />
                </div>
              }
              height={400}
              endMessage={
                <div style={{ textAlign: "center", padding: 8 }}></div>
              }
            >
              <ListGroup>
                {filteredItems?.map((data, i) => {
                  const isDisabled = disabledIds.includes(data.id);
                  return (
                    <ListGroup.Item
                      key={data.id}
                      className={`listItems listStyle ${
                        i % 2 === 0 && "check-active"
                      }`}
                      style={{
                        opacity: isDisabled ? 0.6 : 1,
                        cursor: isDisabled ? "not-allowed" : "pointer",
                      }}
                    >
                      <div
                        style={{
                          paddingLeft: isRadio && "0px",
                        }}
                        className="myTest d-flex custom-control custom-checkbox align-items-center"
                      >
                        {isRadio ? (
                          <>
                            <input
                              type="radio"
                              name="radiogroup"
                              style={{ verticalAlign: "middle" }}
                              id={`customCheck${data.id}`}
                              checked={checked.indexOf(data.id) > -1}
                              disabled={isDisabled}
                              onChange={(ev) => {
                                if (ev.target.checked) {
                                  setchecked([data.id]);
                                }
                              }}
                            />

                            <label
                              style={{
                                width: "100%",
                                margin: "0",
                                marginLeft: "1rem",
                                cursor: isDisabled ? "not-allowed" : "pointer",
                              }}
                              htmlFor={`customCheck${data.id}`}
                            >
                              <span className="text-trunk-prop">
                                {isAvatar ? null : <span>{data?.name}</span>}
                                {isAvatar ? (
                                  <>
                                    <img
                                      src={
                                        data.image ? data.image : defaultAvatar
                                      }
                                      alt="Avatar"
                                      className={
                                        isAvatarCover
                                          ? "avatar"
                                          : "avatar-contain"
                                      }
                                      onError={(ev) =>
                                        (ev.target.src = defaultAvatar)
                                      }
                                    />
                                    <span>{data?.name}</span>
                                  </>
                                ) : null}
                              </span>
                            </label>
                          </>
                        ) : (
                          <>
                            <input
                              type="checkbox"
                              className="custom-control-input"
                              id={`customCheck${data.id}`}
                              checked={checked.indexOf(data.id) > -1}
                              disabled={isDisabled}
                              onChange={(ev) =>
                                addChecked(ev.target.checked, data.id)
                              }
                            />

                            <label
                              className="custom-control-label"
                              htmlFor={`customCheck${data.id}`}
                              style={{
                                width: "100%",
                                cursor: isDisabled ? "not-allowed" : "pointer",
                              }}
                            >
                              <span className="text-trunk-prop">
                                {isAvatar ? null : <span>{data?.name}</span>}
                                {isAvatar ? (
                                  <>
                                    <img
                                      src={
                                        data.image ? data.image : defaultAvatar
                                      }
                                      alt="Avatar"
                                      className="avatar"
                                      onError={(ev) =>
                                        (ev.target.src = defaultAvatar)
                                      }
                                    />
                                    <span className="span-style-none">
                                      {" "}
                                      {data?.name}
                                    </span>
                                  </>
                                ) : null}
                              </span>
                            </label>
                          </>
                        )}
                      </div>
                    </ListGroup.Item>
                  );
                })}
                {loader && (
                  <div className="center-div">
                    <Spinner animation="border" variant="success" />
                  </div>
                )}
              </ListGroup>
            </InfiniteScroll>
          </div>
        )}
      </Modal.Body>
      <Modal.Footer className="no-border">
        <Button
          onClick={() => onBtnClick()}
          style={{ marginRight: 25 }}
          disabled={loader || filteredItems?.length < 1}
        >
          {buttonLabel}
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export default CheckBoxList;
